export const handleTabMenuRestaurant = (data) => {
  return {
    type: 'SET_TAB_MENU_RESTAURANT',
    payload: data,
  };
};
export const handleTabMenuRestaurantPro = (data) => {
  return {
    type: 'SET_MENU_RESTAURANT_PRO',
    payload: data,
  };
};
export const handleTabMenuRestaurantLite = (data) => {
  return {
    type: 'SET_MENU_RESTAURANT_LITE',
    payload: data,
  };
};
export const handleTabMenuSales = (data) => {
  return {
    type: 'SET_TAB_MENU_SALES',
    payload: data,
  };
};
export const setActiveTab = (active) => {
  return {
    type: 'SET_ACTIVE_TAB',
    payload: active,
  };
};
